import React, { memo, useEffect, useRef } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const TIME_HOUR = 'hours';
export const TIME_MINUTE = 'minutes';

const useStyles = makeStyles(theme => ({
  timeSelectorColor: {
    backgroundColor: theme.palette.background.paper,
  },
  labelColor: {
    color: theme.palette.text.primary,
    '&:hover': {
      background: theme.palette.primary.light,
      color: theme.palette.secondary.light,
    },
  },
  customRadioCheckedColor: {
    '& + .label': {
      color: theme.palette.text.primary,
    },
    '&:checked + label': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.light,
    },
  },
}));

const TimePickerItems = ({
  onUpdateTime,
  time,
  position,
  setPosition,
  timeClassName = '',
  className = '',
  timeInterval,
}) => {
  const classes = useStyles();
  const inputRef = useRef([]);

  useEffect(() => {
    if (position) {
      Object.keys(position).forEach(item => {
        if (inputRef) {
          inputRef.current[item].scrollTop = position[item];
        }
      });
    }
  }, [position]);

  const onTimeUpdated = event => {
    const category = event.target.getAttribute('category');

    const { value } = event.target;

    if (!isNaN(value)) {
      if (setPosition && inputRef.current[category]) {
        setPosition({
          ...position,
          [category]: inputRef.current[category].scrollTop,
        });
      }

      onUpdateTime({ category, value });
    }
  };

  return (
    <div className={classnames(styles.timepickerItemsWrapper, className)}>
      <div
        key={1}
        ref={el => (inputRef.current[TIME_HOUR] = el)}
        id="hour"
        className={classnames(
          styles.timeSelector,
          classes.timeSelectorColor,
          timeClassName,
        )}
      >
        {Array.from({ length: 24 }, (v, i) => {
          const hourValue = i < 10 ? `0${i}` : `${i}`;
          return (
            <Box key={i}>
              <input
                type="radio"
                name="hour"
                value={hourValue}
                id={hourValue}
                checked={time ? Number(time[TIME_HOUR]) === i : false}
                onChange={onTimeUpdated}
                /* eslint-disable react/no-unknown-property */
                category={TIME_HOUR}
                className={classes.customRadioCheckedColor}
              />

              <label
                htmlFor={hourValue}
                className={classnames(styles.label, classes.labelColor)}
              >
                {hourValue}
              </label>
            </Box>
          );
        })}
      </div>
      <div
        id="minute"
        ref={el => (inputRef.current[TIME_MINUTE] = el)}
        className={classnames(
          styles.timeSelector,
          classes.timeSelectorColor,
          timeClassName,
        )}
      >
        {Array.from({ length: 60 / timeInterval }, (v, i) => {
          const intervalMin = i * timeInterval;
          const minuteValue =
            intervalMin < 10 ? `0${intervalMin}` : `${intervalMin}`;
          return (
            <Box key={`${minuteValue}--mins`}>
              <input
                type="radio"
                name="minute"
                value={minuteValue}
                id={`${minuteValue}--mins`}
                checked={
                  time ? Number(time[TIME_MINUTE]) === intervalMin : false
                }
                onChange={onTimeUpdated}
                /* eslint-disable react/no-unknown-property */
                category={TIME_MINUTE}
                className={classes.customRadioCheckedColor}
              />
              <label
                htmlFor={`${minuteValue}--mins`}
                className={classnames(styles.label, classes.labelColor)}
              >
                {minuteValue}
              </label>
            </Box>
          );
        })}
      </div>
    </div>
  );
};

TimePickerItems.propTypes = {
  className: PropTypes.string,
  timeClassName: PropTypes.string,
  onUpdateTime: PropTypes.func,
  time: PropTypes.object,
  position: PropTypes.object,
  setPosition: PropTypes.func,
  timeInterval: PropTypes.number,
};

export default memo(TimePickerItems);
